import {applyMiddleware, createStore} from 'redux';
import {composeWithDevTools} from 'redux-devtools-extension';
import thunk from 'redux-thunk'; //for async
import rootReducer from './reducers';

const middleware = [thunk];

// Creates store that contain many sub-states.
export const store = createStore(
    rootReducer,
    {},
    composeWithDevTools(applyMiddleware(...middleware)),
);

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch


